module.exports = __webpack_public_path__ + "img/bg-mine.661f9b8a.png";